// path: client/src/components/TopSlider.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import styled from "styled-components";

const SliderContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
  background-color: #f0f0f0;
  margin-bottom: 20px;

  .swiper {
    width: 100%;
    height: auto;
    touch-action: pan-y;
    transition: height 0.3s ease;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: auto;
  }

  .swiper-slide img {
    width: 100%;
    height: auto;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }

  .swiper-pagination {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.5);
    width: 8px;
    height: 8px;
    opacity: 1;
    margin: 0 5px;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  .swiper-pagination-bullet-active {
    background: white;
    width: 20px;
    height: 8px;
    border-radius: 4px;
  }

  /* Hide navigation arrows on mobile */
  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    opacity: 0.8;
    transition: opacity 0.3s ease;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    
    &:hover {
      opacity: 1;
      background: rgba(0, 0, 0, 0.5);
    }
    
    &::after {
      font-size: 18px;
      font-weight: bold;
    }
  }

  @media (max-width: 768px) {
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  }
`;

const TopSlider = ({ images }) => {
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <SliderContainer>
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={{ 
          clickable: true,
          dynamicBullets: true
        }}
        navigation={true}
        loop={false}
        spaceBetween={0}
        slidesPerView={1}
        speed={500}
        grabCursor={true}
        touchEventsTarget="container"
        touchRatio={1}
        touchAngle={45}
        simulateTouch={true}
        allowTouchMove={true}
        threshold={5}
        resistance={true}
        resistanceRatio={0.85}
        autoHeight={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img 
              src={image} 
              alt={`Slide ${index + 1}`} 
              draggable={false}
              loading={index === 0 ? "eager" : "lazy"}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
};

export default TopSlider;
